import { List } from 'immutable';
import { AppState, AppStateActionParams } from 'records/AppState';
import { RFIQuery } from 'records/RFIQuery';
import queryRFIs, { groupRFIs } from 'utils/queryRFIs';

export interface RFIQueryActions {
  setRFIQuery: (
    actionParams: AppStateActionParams,
    nextRFIQuery: RFIQuery
  ) => AppState;
  setRFITableQuery: (
    actionParams: AppStateActionParams,
    nextRFIQuery: RFIQuery
  ) => AppState;
  queryRFIs: (actionParams: AppStateActionParams) => AppState;
  queryRFIsFromTable: (actionParams: AppStateActionParams) => AppState;
  initRFIQuery: (actionParams: AppStateActionParams) => AppState;
}

const rfiQueryActions: RFIQueryActions = {
  setRFIQuery: (
    { state }: AppStateActionParams,
    nextRFIQuery: RFIQuery
  ): AppState => {
    const { rfis, roles, markups, sheets } = state();

    const qRFIs = queryRFIs(rfis, roles, markups, sheets, nextRFIQuery);
    const groupedRFIs = groupRFIs(qRFIs);

    return state()
      .set('rfiQuery', nextRFIQuery)
      .set('queriedRFIs', qRFIs.keySeq().toList())
      .set('queriedRFIGroups', groupedRFIs);
  },

  setRFITableQuery: (
    { state }: AppStateActionParams,
    nextRFIQuery: RFIQuery
  ): AppState => {
    const { rfis, roles, markups, sheets } = state();
    const qRFIs = queryRFIs(rfis, roles, markups, sheets, nextRFIQuery);
    const groupedRFIs = groupRFIs(qRFIs);

    return state()
      .set('rfiTableQuery', nextRFIQuery)
      .set('queriedRFIs', qRFIs.keySeq().toList())
      .set('queriedRFIGroups', groupedRFIs);
  },

  queryRFIs: ({ state }: AppStateActionParams): AppState => {
    const { rfis, roles, markups, sheets, rfiQuery } = state();

    const qRFIs = queryRFIs(rfis, roles, markups, sheets, rfiQuery);
    const queriedRFIs = List(qRFIs.keys());
    const groupedRFIs = groupRFIs(qRFIs);

    return state()
      .set('queriedRFIs', queriedRFIs)
      .set('queriedRFIGroups', groupedRFIs);
  },

  queryRFIsFromTable: ({ state }: AppStateActionParams): AppState => {
    const { rfis, roles, markups, sheets, rfiTableQuery } = state();

    const qRFIs = queryRFIs(rfis, roles, markups, sheets, rfiTableQuery);
    const queriedRFIs = List(qRFIs.keys());
    const groupedRFIs = groupRFIs(qRFIs);

    const updatedState = state()
      .set('roles', roles)
      .set('markups', markups)
      .set('sheets', sheets)
      .set('rfiTableQuery', rfiTableQuery)
      .set('queriedRFIs', queriedRFIs)
      .set('queriedRFIGroups', groupedRFIs);

    return updatedState;
  },

  initRFIQuery: ({ state }: AppStateActionParams): AppState => {
    const { rfis, roles, markups, sheets } = state();
    const rfiQuery = new RFIQuery();

    const qRFIs = queryRFIs(rfis, roles, markups, sheets, rfiQuery);
    const groupedRFIs = groupRFIs(qRFIs);

    return state()
      .set('rfiQuery', rfiQuery)
      .set('queriedRFIs', List(qRFIs.keys()))
      .set('queriedRFIGroups', groupedRFIs);
  },
};

export default rfiQueryActions;
